module.exports = __webpack_public_path__ + "static/media/Q11-1.f365ed40.jpg";